import axios from 'axios'
import { erpTypes as types } from '../store/types/erpTypes'
import {
  toggleErrorModal,
} from '../store/actions/requestActions'

import { handleValidations } from '../utils/handleValidations'

const redirectAuthUrl = process.env.REACT_APP_AUTH_ROUTE
const appUrl = process.env.REACT_APP_URL
const baseUrl = process.env.REACT_APP_BACK_URL
const baseUrlClick = process.env.REACT_APP_LOBBY_URL
const apiVersion = 'v1'

const ErpRepository = async props => {
  const {
    method,
    datasourceUrl,
    data,
    id,
    type,
    dataOperations,
    params,
    formatImag,
    diferentBaseUrl,
    online,
    cancelToken,
  } = props
  //const dispatch = useDispatch();
  var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (!timezone) {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!timezone) {
      timezone = 'America/La_Paz'
    }
  }
  const options = {
    method: method,
    url: apiVersion + '/' + datasourceUrl,
    baseURL: diferentBaseUrl ? baseUrlClick : baseUrl,
    withCredentials: true,
    headers: { Timezone: timezone },
  }

  if (method === 'POST') {
    options.data = data
  }

  if (method === 'DELETE') {
    options.data = data
    options.url = options.url + 0 + '/'
  }

  if (method === 'PUT' || method === 'PATCH') {
    options.data = data
    options.url = options.url + id + '/'
  }

  if (type === 'FIND_BY_ID' && id !== null) {
    options.url = options.url + id + '/'
  }

  if (type === 'FIND_BY_ID_VAR_TURN' && id !== null) {
    options.url = options.url + '?turn=' + id
  }

  if (type === 'FIND_BY_ID_WAREHOUSE' && id !== null) {
    options.url = options.url + '?warehouse=' + id
  }

  if (cancelToken !== undefined && cancelToken !== null) {
    options.cancelToken = cancelToken
  }

  if (formatImag) {
    options.headers = {
      ...options.headers,
      'Content-Type': 'application/json',
    }
  }

  if (dataOperations != null) {
    options.headers = {
      ...options.headers,
      'Data-Operations': JSON.stringify(dataOperations),
    }
  }

  if (method === 'GET') {
    if (params) {
      options.params = params
    }
    if (data) {
      options.data = data
    }
  }

  return axios(options)
    .then(({ data, status, headers }) => {
      if (online !== undefined && online === false) {
        throw new Error('Network Error')
      }

      if (props.dispatch) {
        const tuGerentePack = parseInt(headers['tugerente-pack'])
        if (tuGerentePack) {
          props.dispatch({
            type: types.CHANGE_PACK,
            payload: {
              pack: tuGerentePack,
            },
          })
        }
      }
      return data
    })
    .catch(error => {
      props.ChangeVariableDoubleClick && props.ChangeVariableDoubleClick()
      let handled = false
      if (typeof error.status === 'undefined') {
        handled = true
      }

      if (error.response && error.response.data) {
        if (
          error.response.data.error === 400 ||
          error.response.data.error === 500 ||
          error.response.data.error === 504 ||
          error.response.data.error === 501
        ) {
          let dataError = error.response.data
          props.dispatch(handleValidations(dataError))
        }
      }

      if (error.response && error.response.status === 401) {
        let url = new URL(window.location.href)
        let params = new URLSearchParams(url.search)
        let source = params.get('source')
        if (source === 'whatsapp' || url.pathname === '/iniciarsesion') {
          if (url.pathname !== '/iniciarsesion') {
            window.location.href = appUrl + 'iniciarsesion'
          }
        } else {
          handled = true
          window.location.href = redirectAuthUrl
        }
      }
      if (handled === false) {
        handled = true
        props.dispatch &&
          props.dispatch(
            toggleErrorModal(true, 'Oops! Ha ocurrido un error inesperado')
          )
      }

      if (error.message && error.message === 'cancelado') {
      } else {
        throw error
      }
    })
    .finally(() => {})
}

export default ErpRepository
